var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 19.0002H17.4099L20.7099 15.7102C20.8982 15.5219 21.004 15.2665 21.004 15.0002C21.004 14.7339 20.8982 14.4785 20.7099 14.2902C20.5216 14.1019 20.2662 13.9961 19.9999 13.9961C19.7336 13.9961 19.4782 14.1019 19.2899 14.2902L14.2899 19.2902C14.1989 19.3853 14.1275 19.4974 14.0799 19.6202C13.9799 19.8636 13.9799 20.1367 14.0799 20.3802C14.1275 20.5029 14.1989 20.6151 14.2899 20.7102L19.2899 25.7102C19.3829 25.8039 19.4935 25.8783 19.6153 25.9291C19.7372 25.9798 19.8679 26.006 19.9999 26.006C20.1319 26.006 20.2626 25.9798 20.3845 25.9291C20.5063 25.8783 20.6169 25.8039 20.7099 25.7102C20.8036 25.6172 20.878 25.5066 20.9288 25.3848C20.9796 25.2629 21.0057 25.1322 21.0057 25.0002C21.0057 24.8682 20.9796 24.7375 20.9288 24.6156C20.878 24.4937 20.8036 24.3831 20.7099 24.2902L17.4099 21.0002H24.9999C25.2651 21.0002 25.5195 20.8948 25.707 20.7073C25.8945 20.5198 25.9999 20.2654 25.9999 20.0002C25.9999 19.735 25.8945 19.4806 25.707 19.2931C25.5195 19.1055 25.2651 19.0002 24.9999 19.0002Z",
    fill: "#38383A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#38383A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.7cf4ec78f49e4c02aef2c47b696e0e65.svg";
export { ForwardRef as ReactComponent };